module.exports = __webpack_public_path__ + "img/mc_idcheck.f4bf252f.svg";